import React from "react";
import Header from "../common/header";
import ITProjectCard from "../layout/project/itproject-card";
import Footer from "../common/footer";
import ITprojectHead from "../layout/project/itproject-head";
import ITprojectContent from "../layout/project/itproject-content";
function ITproject() {
    return (
        <div>
            <Header />
            <br />
            <ITprojectHead />
            <br />
            <ITprojectContent />
            <br />
            <ITProjectCard />
            <br />
            <Footer />
        </div>
    );
};

export default ITproject;